package kz.dentalcrm.app.data

import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.core.utils.map
import kz.dentalcrm.app.data.network.ServicesApi
import kz.dentalcrm.app.data.network.request_model.AddServiceRequest
import kz.dentalcrm.app.data.network.response_model.services.ServiceItem
import kz.dentalcrm.app.data.network.response_model.services_category.ServiceCategory
import kz.dentalcrm.app.domain.ServicesRepository

class ServicesRepositoryImpl(
    private val servicesServiceApi: ServicesApi
) : ServicesRepository {

    override suspend fun getServices(
        search: String,
        category: String,
        page: Int,
        pageSize: Int
    ): Result<List<ServiceItem>?> = servicesServiceApi.getServices(
        page = page,
        perPage = pageSize,
        category = category,
        search = search
    ).map { it?.data }

    override suspend fun getServiceCategories(): Result<List<ServiceCategory>?> =
        servicesServiceApi.getServiceCategories()

    override suspend fun addServiceCategory(name: String): Result<ServiceCategory?> =
        servicesServiceApi.addServiceCategory(
            name = name
        )

    override suspend fun updateServiceCategory(id: Int, name: String): Result<Any?> =
        servicesServiceApi.updateServiceCategory(id, name)

    override suspend fun deleteServiceCategory(id: String): Result<Any?> =
        servicesServiceApi.deleteServiceCategory(id = id)

    override suspend fun addService(request: AddServiceRequest): Result<Any?> =
        servicesServiceApi.addService(request = request)

    override suspend fun editService(request: AddServiceRequest, id: Int): Result<Any?> =
        servicesServiceApi.editService(request = request, id = id)

    override suspend fun deleteService(id: Int): Result<Any?> =
        servicesServiceApi.deleteService(id = id)
}
